export const TECH_ERROR_TITLE = 'Please try that again';
export const TECH_ERROR_DESC = 'Something went wrong on our end';
export const NO_MATCH_FOUND_TITLE = 'No match found';
export const NO_MATCH_FOUND_TITLE_IDENTITY_INFO = 'We haven\'t found a match yet';
export const FIRST_THREE_FAILED_ATTEMPTS_DESC_DEMO_SEARCH = 'Make sure you use the info the pharmacy has.';
export const TWO_ATTEMPTS_REMAINING_DESC = 'You can search for this person\'s pharmacy records 2 more times.';
export const TWO_ATTEMPTS_REMAINING_PET_DESC = 'You can search for this pet\'s pharmacy records 2 more times.';
export const LAST_FAILED_ATTEMPTS_DESC_DEMO_SEARCH =
  'You can search for your records 1 more time.\n\nIf we don\'t find a match, you\'ll have to wait 15 minutes before trying again.';
export const LAST_FAILED_ATTEMPTS_DESC_IDENTITY_INFO_SEARCH =
  'You can search 1 more time.\n\nIf we don\'t find a match, you\'ll have to wait 15 minutes to try again.';
export const LOCKED_ERROR = 'user is locked due to many failed attempts';
export const PERSONAL_INFO_MESSAGE = 'Try using their personal info, or enter their prescription info again.';
export const PRESCRIPTION_LABEL_MESSAGE = 'Try using their prescription label, or enter their personal info again.';
export const OWN_INFO_ERROR_TITLE = 'You entered your own info';
export const OWN_INFO_ERROR_DESC1 = 'To view and manage your pharmacy records, ';
export const OWN_INFO_ERROR_LINK = 'go to your pharmacy dashboard';
export const OWN_INFO_ERROR_HREF = '/pharmacy/v3/dashboard';
export const OWN_INFO_ERROR_DESC2 = 'To care for someone else, enter their info.';

export const RX_MERGE_ERRORS = {
  NOT_OWN_INFO: {
    title: 'Something went wrong',
    description: `The patient's information you entered does not match the stored information for the logged in user.`
  },
  ALREADY_EXISTS: {
    title: 'We cannot connect your records',
    description: 'This patient prescriptions are being accessed through a different CVS account'
  },
  ALREADY_TIED: {
    title: 'Something went wrong',
    description:
      'Sorry, we are unable to process your request. This CVS Account is already tied to an prescription account. For assistance please, call customer care at 1-888-607-4287'
  }
};

export const UNIFIED_REGISTRATION_ERRORS = {
  NO_MATCH_FOUND_TITLE: 'We couldn\'t find you',
  NO_MATCH_FOUND_DESCRIPTION: 'Check your info to make sure it\'s right. If you need help, call us at',
  CLIENT_BLOCKED_TITLE: 'You need to register another way',
  CLIENT_BLOCKED_DESC:
    'Call us at the number on your Member ID card to complete your registration. We\'re available Monday through Friday from 7 PM to 9 PM (CT), and Saturday from 8 AM to 12 PM (CT).',
  LOCKED_TITLE: 'Your account has been locked',
  LOCKED_DESCRIPTION:
    'To protect your privacy, your account has been locked by a member of our Customer Care team. Please contact Customer Care for assistance.',
  EXPIRED_TITLE: 'Your plan has expired',
  EXPIRED_DESCRIPTION:
    'You need current or recent coverage to register. If you think there\'s been a mistake, call the number on your Member ID card.',
  UNDER_AGE_TITLE: 'You don\'t meet the minimum age requirement',
  UNDER_AGE_DESCRIPTION: 'If you have questions, please call the number on your Member ID card.',
  FUTURE_ELIGIBILITY_TITLE: 'It\'s too early to register',
  FUTURE_ELIGIBILITY_DESCRIPTION:
    'You can register once your benefits period begins. If you have any questions, please call the number on your Member ID card.',
  ELIGIBLE_PLAN_NOT_FOUND_TITLE: 'We can\'t register you',
  ELIGIBLE_PLAN_NOT_FOUND_DESCRIPTION: 'We couldn\'t find any eligible plan to register',
  ACCOUNT_LOCKED: 'Your registration is locked for 30 minutes',
  ACCOUNT_LOCKED_DESCRIPTION: 'There were too many tries to verify your mobile number. If you need help, call us at',
  MemberId_Title: `We couldn't find you`,
  MemberId_Message: `Please try with Member Id number. Your Member Id number can be found on your prescription or insurance card.`
};

export const FORGOT_USERNAME_ERRORS = {
  NOT_REGISTERED_CAREMARK: {
    TITLE: 'You\'re not registered for CVS Caremark yet',
    DESCRIPTION: 'To access and manage your prescription benefits, register for a CVS Caremark account.',
    CTA: 'Register with CVS Caremark'
  },
  NOT_REGISTERED_SPECIALTY: {
    TITLE: 'You\'re not registered for CVS Specialty yet',
    DESCRIPTION: 'To access and manage your prescription benefits, register for a CVS Specialty account.',
    CTA: 'Register with CVS Specialty'
  },
  USER_NOT_FOUND_TITLE: 'One or more entries does not match our records',
  USER_NOT_FOUND_DESCRIPTION: 'Review your entries and try again'
};

export const UNLOCK_USER_ERRORS = {
  LOOKUP_FAILED_TITLE: 'We couldn\'t find you',
  LOOKUP_FAILED_DESCRIPTION: 'Please double check your info to make sure it\'s right.',
  CUSTOMER_CARE_LOCK_TITLE: 'This account cannot be unlocked online',
  CUSTOMER_CARE_LOCK_DESCRIPTION: 'Please call customer care at',
  LOOKUP_LOCKED_TITLE: 'Your unlock attempt is locked for 30 minutes',
  LOOKUP_LOCKED_DESCRIPTION: 'There were too many tries to verify your information. If you need help, call us at',
  EMAIL_NOT_FOUND_TITLE: 'The provided email address was not found in our system',
  EMAIL_NOT_FOUND_DESCRIPTION: 'Please double check your email'
};

// Error message link text
export const ERROR_LINK_TEXT = {
  TRY_PERSONAL_INFO: 'Try using their personal info',
  TRY_PRESCRIPTION_LABEL: 'Try using their prescription label',
  ENTER_PRESCRIPTION_AGAIN: 'or enter their prescription info again',
  ENTER_PERSONAL_INFO_AGAIN: 'or enter their personal info again'
};

// Translation configuration for lookup errors
export const LOOKUP_ERRORS_TRANSLATION_CONFIG = [
  { key: 'tech_error_title', message: TECH_ERROR_TITLE },
  { key: 'tech_error_desc', message: TECH_ERROR_DESC },
  { key: 'no_match_found_title', message: NO_MATCH_FOUND_TITLE },
  { key: 'no_match_found_title_identity_info', message: NO_MATCH_FOUND_TITLE_IDENTITY_INFO },
  { key: 'two_attempts_remaining_desc', message: TWO_ATTEMPTS_REMAINING_DESC },
  { key: 'two_attempts_remaining_pet_desc', message: TWO_ATTEMPTS_REMAINING_PET_DESC },
  { key: 'last_failed_attempts_desc_demo_search', message: LAST_FAILED_ATTEMPTS_DESC_DEMO_SEARCH },
  { key: 'last_failed_attempts_desc_identity_info_search', message: LAST_FAILED_ATTEMPTS_DESC_IDENTITY_INFO_SEARCH },
  { key: 'personal_info_message', message: PERSONAL_INFO_MESSAGE },
  { key: 'prescription_label_message', message: PRESCRIPTION_LABEL_MESSAGE },
  { key: 'own_info_error_title', message: OWN_INFO_ERROR_TITLE },
  { key: 'own_info_error_desc1', message: OWN_INFO_ERROR_DESC1 },
  { key: 'own_info_error_link', message: OWN_INFO_ERROR_LINK },
  { key: 'own_info_error_desc2', message: OWN_INFO_ERROR_DESC2 },
  { key: 'try_personal_info', message: ERROR_LINK_TEXT.TRY_PERSONAL_INFO },
  { key: 'try_prescription_label', message: ERROR_LINK_TEXT.TRY_PRESCRIPTION_LABEL },
  { key: 'enter_prescription_again', message: ERROR_LINK_TEXT.ENTER_PRESCRIPTION_AGAIN },
  { key: 'enter_personal_info_again', message: ERROR_LINK_TEXT.ENTER_PERSONAL_INFO_AGAIN },
  { key: 'not_own_info', message: JSON.stringify(RX_MERGE_ERRORS.NOT_OWN_INFO) },
  { key: 'already_exists', message: JSON.stringify(RX_MERGE_ERRORS.ALREADY_EXISTS) },
  { key: 'already_tied', message: JSON.stringify(RX_MERGE_ERRORS.ALREADY_TIED) }
];

// Process translations
export const processLookupErrorsTranslations = (
  translatedItems: Record<string, string>
): {
  TECH_ERROR_TITLE: string;
  TECH_ERROR_DESC: string;
  NO_MATCH_FOUND_TITLE: string;
  NO_MATCH_FOUND_TITLE_IDENTITY_INFO: string;
  TWO_ATTEMPTS_REMAINING_DESC: string;
  TWO_ATTEMPTS_REMAINING_PET_DESC: string;
  LAST_FAILED_ATTEMPTS_DESC_DEMO_SEARCH: string;
  LAST_FAILED_ATTEMPTS_DESC_IDENTITY_INFO_SEARCH: string;
  PERSONAL_INFO_MESSAGE: string;
  PRESCRIPTION_LABEL_MESSAGE: string;
  OWN_INFO_ERROR_TITLE: string;
  OWN_INFO_ERROR_DESC1: string;
  OWN_INFO_ERROR_LINK: string;
  OWN_INFO_ERROR_DESC2: string;
  ERROR_LINK_TEXT: {
    TRY_PERSONAL_INFO: string;
    TRY_PRESCRIPTION_LABEL: string;
    ENTER_PRESCRIPTION_AGAIN: string;
    ENTER_PERSONAL_INFO_AGAIN: string;
  };
  RX_MERGE_ERRORS: {
    NOT_OWN_INFO: {
      title: string;
      description: string;
    };
    ALREADY_EXISTS: {
      title: string;
      description: string;
    };
    ALREADY_TIED: {
      title: string;
      description: string;
    };
  };
} => {
  if (!translatedItems || Object.keys(translatedItems).length === 0) {
    return {
      TECH_ERROR_TITLE,
      TECH_ERROR_DESC,
      NO_MATCH_FOUND_TITLE,
      NO_MATCH_FOUND_TITLE_IDENTITY_INFO,
      TWO_ATTEMPTS_REMAINING_DESC,
      TWO_ATTEMPTS_REMAINING_PET_DESC,
      LAST_FAILED_ATTEMPTS_DESC_DEMO_SEARCH,
      LAST_FAILED_ATTEMPTS_DESC_IDENTITY_INFO_SEARCH,
      PERSONAL_INFO_MESSAGE,
      PRESCRIPTION_LABEL_MESSAGE,
      OWN_INFO_ERROR_TITLE,
      OWN_INFO_ERROR_DESC1,
      OWN_INFO_ERROR_LINK,
      OWN_INFO_ERROR_DESC2,
      ERROR_LINK_TEXT,
      RX_MERGE_ERRORS
    };
  }

  return {
    TECH_ERROR_TITLE: translatedItems[TECH_ERROR_TITLE] || TECH_ERROR_TITLE,
    TECH_ERROR_DESC: translatedItems[TECH_ERROR_DESC] || TECH_ERROR_DESC,
    NO_MATCH_FOUND_TITLE: translatedItems[NO_MATCH_FOUND_TITLE] || NO_MATCH_FOUND_TITLE,
    NO_MATCH_FOUND_TITLE_IDENTITY_INFO:
      translatedItems[NO_MATCH_FOUND_TITLE_IDENTITY_INFO] || NO_MATCH_FOUND_TITLE_IDENTITY_INFO,
    TWO_ATTEMPTS_REMAINING_DESC: translatedItems[TWO_ATTEMPTS_REMAINING_DESC] || TWO_ATTEMPTS_REMAINING_DESC,
    TWO_ATTEMPTS_REMAINING_PET_DESC:
      translatedItems[TWO_ATTEMPTS_REMAINING_PET_DESC] || TWO_ATTEMPTS_REMAINING_PET_DESC,
    LAST_FAILED_ATTEMPTS_DESC_DEMO_SEARCH:
      translatedItems[LAST_FAILED_ATTEMPTS_DESC_DEMO_SEARCH] || LAST_FAILED_ATTEMPTS_DESC_DEMO_SEARCH,
    LAST_FAILED_ATTEMPTS_DESC_IDENTITY_INFO_SEARCH:
      translatedItems[LAST_FAILED_ATTEMPTS_DESC_IDENTITY_INFO_SEARCH] || LAST_FAILED_ATTEMPTS_DESC_IDENTITY_INFO_SEARCH,
    PERSONAL_INFO_MESSAGE: translatedItems[PERSONAL_INFO_MESSAGE] || PERSONAL_INFO_MESSAGE,
    PRESCRIPTION_LABEL_MESSAGE: translatedItems[PRESCRIPTION_LABEL_MESSAGE] || PRESCRIPTION_LABEL_MESSAGE,
    OWN_INFO_ERROR_TITLE: translatedItems[OWN_INFO_ERROR_TITLE] || OWN_INFO_ERROR_TITLE,
    OWN_INFO_ERROR_DESC1: translatedItems[OWN_INFO_ERROR_DESC1] || OWN_INFO_ERROR_DESC1,
    OWN_INFO_ERROR_LINK: translatedItems[OWN_INFO_ERROR_LINK] || OWN_INFO_ERROR_LINK,
    OWN_INFO_ERROR_DESC2: translatedItems[OWN_INFO_ERROR_DESC2] || OWN_INFO_ERROR_DESC2,
    ERROR_LINK_TEXT: {
      TRY_PERSONAL_INFO: translatedItems[ERROR_LINK_TEXT.TRY_PERSONAL_INFO] || ERROR_LINK_TEXT.TRY_PERSONAL_INFO,
      TRY_PRESCRIPTION_LABEL:
        translatedItems[ERROR_LINK_TEXT.TRY_PRESCRIPTION_LABEL] || ERROR_LINK_TEXT.TRY_PRESCRIPTION_LABEL,
      ENTER_PRESCRIPTION_AGAIN:
        translatedItems[ERROR_LINK_TEXT.ENTER_PRESCRIPTION_AGAIN] || ERROR_LINK_TEXT.ENTER_PRESCRIPTION_AGAIN,
      ENTER_PERSONAL_INFO_AGAIN:
        translatedItems[ERROR_LINK_TEXT.ENTER_PERSONAL_INFO_AGAIN] || ERROR_LINK_TEXT.ENTER_PERSONAL_INFO_AGAIN
    },
    RX_MERGE_ERRORS: {
      NOT_OWN_INFO: {
        title: translatedItems[RX_MERGE_ERRORS.NOT_OWN_INFO.title] || RX_MERGE_ERRORS.NOT_OWN_INFO.title,
        description:
          translatedItems[RX_MERGE_ERRORS.NOT_OWN_INFO.description] || RX_MERGE_ERRORS.NOT_OWN_INFO.description
      },
      ALREADY_EXISTS: {
        title: translatedItems[RX_MERGE_ERRORS.ALREADY_EXISTS.title] || RX_MERGE_ERRORS.ALREADY_EXISTS.title,
        description:
          translatedItems[RX_MERGE_ERRORS.ALREADY_EXISTS.description] || RX_MERGE_ERRORS.ALREADY_EXISTS.description
      },
      ALREADY_TIED: {
        title: translatedItems[RX_MERGE_ERRORS.ALREADY_TIED.title] || RX_MERGE_ERRORS.ALREADY_TIED.title,
        description:
          translatedItems[RX_MERGE_ERRORS.ALREADY_TIED.description] || RX_MERGE_ERRORS.ALREADY_TIED.description
      }
    }
  };
};
